import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from 'components/Input';
import TextButton from 'components/TextButton';
import IconHide from 'resources/Icon-Hide.png';
import IconShow from 'resources/Icon-Show.png';
import './ViewablePasswordField.css';

class ViewablePasswordField extends Component {
  constructor(props) {
    super(props);

    this.handleToggle = this.handleToggle.bind(this);

    this.state = {
      showPassword: false
    };
  }

  handleToggle() {
    if (this.props.toggleVisibility) {
      this.props.toggleVisibility();
    } else {
      this.setState({ showPassword: !this.state.showPassword });
    }
  }

  renderSubLabel() {
    const override = this.props.showPassword !== undefined;
    const show = override ? this.props.showPassword : this.state.showPassword;
    return (
      <TextButton
        className="password-label-toggle"
        type="button"
        onClick={this.handleToggle}
        aria-label={`${show ? 'Hide' : 'Show'} Password`}
      >
        <img src={show ? IconShow : IconHide} alt="" />
      </TextButton>
    );
  }

  renderControlWithToggle = control => {
    const override = this.props.showPassword !== undefined;
    const show = override ? this.props.showPassword : this.state.showPassword;
    return (
      <div className="input-control-sublabel-container">
        {control}
        <div className="input-sublabel-container">
          <TextButton
            className="password-label-toggle-icons"
            type="button"
            onClick={this.handleToggle}
            aria-label={`${show ? 'Hide' : 'Show'} Password`}
          >
            {show ? this.props.hideIcon : this.props.showIcon}
          </TextButton>
        </div>
      </div>
    );
  };

  render() {
    const { showPassword, toggleVisibility, hideIcon, showIcon, ...rest } =
      this.props;
    const override = this.props.showPassword !== undefined;
    const show = override ? this.props.showPassword : this.state.showPassword;
    const iconsSet = showIcon && hideIcon;
    const subLabel =
      (!override || toggleVisibility) && !iconsSet
        ? this.renderSubLabel()
        : null;
    const controlWrapperFn =
      (!override || toggleVisibility) && iconsSet
        ? this.renderControlWithToggle
        : null;
    return (
      <Input
        wrapperClass="viewable-password-field"
        {...rest}
        type={show ? 'text' : 'password'}
        subLabel={subLabel}
        controlWrapperFn={controlWrapperFn}
      />
    );
  }
}

ViewablePasswordField.propTypes = {
  showPassword: PropTypes.bool,
  toggleVisibility: PropTypes.func
};

export default ViewablePasswordField;
